// extracted by mini-css-extract-plugin
export default {"arrow":"Arrows_arrow__-Yxnw","invisible":"Arrows_invisible__RKAnq"};